<template>
<b-container fluid style="background-color: #f05d2e;">
    <b-form @submit.prevent="onSubmit">

      <b-form-group description="Let us know your name." label="Enter your name">
        <b-row class="my-1">
          <b-col sm="3">
            <label>Nom :</label>
          </b-col>
          <b-col sm="6">
            <b-form-input type="text" v-model="nom"></b-form-input>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group>
        <b-row>
          <b-col sm="3">
            <label>Prenom :</label>
          </b-col>
          <b-col sm="6">
            <b-form-input type="text" v-model="prenom"></b-form-input>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group>
        <b-row class="my-1">
          <b-col sm="3">
            <label>Téléphone :</label>
          </b-col>
          <b-col sm="6">
            <b-form-input type="tel" v-model="tel"></b-form-input>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group>
        <b-row class="my-1">
          <b-col sm="3">
            <label>Adresse :</label>
          </b-col>
          <b-col sm="6">
            <b-form-input type="text" v-model="adresse"></b-form-input>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group>
        <b-row class="my-1">
          <b-col sm="3">
            <label>email :</label>
          </b-col>
          <b-col sm="6">
            <b-form-input type="email" v-model="email"></b-form-input>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group>
        <b-row class="my-1">
          <b-col sm="3">
            <label>Mot de passe :</label>
          </b-col>
          <b-col sm="6">
            <b-form-input type="password" v-model="password"></b-form-input>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group>
        <b-row class="my-1">
          <b-col sm="3">
            <label>Confirmation du mot de passe :</label>
          </b-col>
          <b-col sm="6">
            <b-form-input type="password" v-model="passwordconfirm"></b-form-input>
          </b-col>
        </b-row>
      </b-form-group>
  <div class="col">
    <b-button class="btn-primary" type="submit">Submit</b-button>
  </div>
    
    </b-form>



  </b-container>
 <!-- 
    <div class="container-fluid">
      <div class="row no-gutter">
        <div class="login d-flex align-items-center py-5">

          <div class="container">
            <div class="row">
              <div class="col-lg-10 col-xl-7 mx-auto">
                <h3 class="display-4">Split login page!</h3>
                <p class="text-muted mb-4">Create a login split page using Reactjs & Bootstrap 5.</p>
                <form @submit.prevent="onSubmit">
                  <div class="mb-3">
                    <input id="nom" type="text" placeholder="Nom" v-model="nom" required="" autofocus=""
                      class="form-control rounded-pill border-0 shadow-sm px-4" />
                  </div>
                  <div class="mb-3">
                    <input id="prenom" type="text" placeholder="Prenom" v-model="prenom" required="" autofocus=""
                      class="form-control rounded-pill border-0 shadow-sm px-4" />
                  </div>
                  <div class="mb-3">
                    <input id="tel" type="tel" placeholder="Telephone" v-model="tel" required="" autofocus=""
                      class="form-control rounded-pill border-0 shadow-sm px-4" />
                  </div>
                  <div class="mb-3">
                    <input id="adresse" type="text" placeholder="Adresse" v-model="adresse" required="" autofocus=""
                      class="form-control rounded-pill border-0 shadow-sm px-4" />
                  </div>
                  <div class="mb-3">
                    <input id="email" type="email" placeholder="Email" v-model="email" required="" autofocus=""
                      class="form-control rounded-pill border-0 shadow-sm px-4" />
                  </div>
                  <div class="mb-3">
                    <input id="password" type="password" placeholder="Mot de passe" v-model="password" required=""
                      class="form-control rounded-pill border-0 shadow-sm px-4 text-primary" />
                  </div>
                  <div class="mb-3">
                    <input id="password" type="password" placeholder="Confirmez le mot de passe" v-model="passwordconfirm" required=""
                      class="form-control rounded-pill border-0 shadow-sm px-4 text-primary" />
                  </div>
                  <div class="form-check">
                    <input id="customCheck1" type="checkbox" checked class="form-check-input" />
                    <label for="customCheck1" class="form-check-label">Remember password</label>
                  </div>
                  <div class="d-grid gap-2 mt-2">
                    <button type="submit"
                      class="btn btn-primary btn-block text-uppercase mb-2 rounded-pill shadow-sm">Sign up</button>
                  </div>


                </form>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>-->







</template>
<script>
import axios from 'axios'
import { mapActions, mapGetters, mapMutations } from "vuex";


export default {
  name: 'Signup',
  data() {
    return {
      nom: '',
      prenom: '',
      tel: '',
      adresse: '',
      email: '',
      password: '',
      passwordconfirm: ''
    }
  },
  methods: {
    ...mapActions(["register"]),
    async onSubmit() {
      const form = {
        nom: this.nom,
        prenom: this.prenom,
        email: this.email,
        tel: this.tel,
        adresse: this.adresse,
        password: this.password,
        passwordconfirm: this.passwordconfirm,
      }
      this.register(form).then(window.location.href = '/login')
      // this.router.push('/login')
    }
  }
}
</script>

<style scoped>

 .btn-primary{
    background: #f05d2e !important;  
    border: unset !important;
    width: 25%;
    }
</style>